export const ADMIN_ROLE_CODES = ['admin', 'superuser']
export const SHARED_DASHBOARD_ROLE_CODES = ['admin', 'superuser']

export function extractRoleCode (user) {
  if (!user) {
    return null
  }

  if (user?.role?.role_code) {
    return user.role.role_code
  }

  return user?.role || null
}

export function isAdminRole (userOrRoleCode) {
  const roleCode = typeof userOrRoleCode === 'string'
    ? userOrRoleCode
    : extractRoleCode(userOrRoleCode)

  return ADMIN_ROLE_CODES.includes(roleCode)
}

export function getHomeRouteByRoleCode (userOrRoleCode) {
  const roleCode = typeof userOrRoleCode === 'string'
    ? userOrRoleCode
    : extractRoleCode(userOrRoleCode)

  if (roleCode === 'student') {
    return 'student.dashboard'
  }

  if (['security_personel', 'dsm'].includes(roleCode)) {
    return 'security.dashboard'
  }

  if (SHARED_DASHBOARD_ROLE_CODES.includes(roleCode)) {
    return 'shared.dashboard'
  }

  return 'shared.login'
}
